import { FastForward as FastForwardIcon } from '@mui/icons-material';

const FastForward = (): JSX.Element => <FastForwardIcon fontSize="inherit" />;

export default FastForward;
